const messagingApiBaseUrl =
  process.env.REACT_APP_PAYMENT_API_URL ||
  'https://southamerica-east1-coloniadeferiasss.cloudfunctions.net/paymentApi';

export interface MessagingSettings {
  adminEnabled: boolean;
  responsibleEnabled: boolean;
  adminPhone: string;
  instanceName: string;
}

export interface EvolutionInstance {
  id: string;
  name: string;
  connectionStatus: string;
  owner: string;
  profileName: string;
  profilePictureUrl: string;
}

export interface EvolutionConnection {
  instanceName: string;
  status: string;
  qrCode: string;
  pairingCode: string;
  count: number;
}

const request = async <T>(path: string, options?: RequestInit): Promise<T> => {
  const response = await fetch(`${messagingApiBaseUrl.replace(/\/$/, '')}${path}`, options);
  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.error || 'Erro na configuração de mensagens.');
  return data;
};

export const getMessagingSettings = async () => {
  const data = await request<{ success: true; settings: MessagingSettings }>('/messaging/settings');
  return data.settings;
};

export const saveMessagingSettings = async (settings: MessagingSettings) => {
  await request('/messaging/settings', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(settings)
  });
};

export const getEvolutionInstances = async () => {
  const data = await request<{ success: true; instances: EvolutionInstance[] }>('/messaging/instances');
  return data.instances;
};

export const createEvolutionInstance = async (instanceName: string) => {
  const data = await request<{ success: true; instance: EvolutionInstance; connection: EvolutionConnection }>('/messaging/instances', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ instanceName })
  });
  return data;
};

export const connectEvolutionInstance = async (instanceName: string) => {
  const data = await request<{ success: true; connection: EvolutionConnection }>(`/messaging/instances/${encodeURIComponent(instanceName)}/connect`);
  return data.connection;
};

export const getEvolutionInstanceStatus = async (instanceName: string) => {
  const data = await request<{ success: true; connection: EvolutionConnection }>(`/messaging/instances/${encodeURIComponent(instanceName)}/status`);
  return data.connection;
};

export const restartEvolutionInstance = async (instanceName: string) => {
  const data = await request<{ success: true; connection: EvolutionConnection }>(`/messaging/instances/${encodeURIComponent(instanceName)}/restart`, { method: 'PUT' });
  return data.connection;
};

export const logoutEvolutionInstance = async (instanceName: string) => {
  await request(`/messaging/instances/${encodeURIComponent(instanceName)}/logout`, { method: 'DELETE' });
};

export const deleteEvolutionInstance = async (instanceName: string) => {
  await request(`/messaging/instances/${encodeURIComponent(instanceName)}`, { method: 'DELETE' });
};

export const testEvolutionMessage = async (instanceName: string, phone: string) => {
  await request('/messaging/test', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ instanceName, phone })
  });
};

export const sendRegistrationConfirmation = async (registrationId: string) => {
  await request('/messaging/send-confirmation', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ registrationId })
  });
};
